export default "__VITE_ASSET__f87e928e__"